module.exports = "/_next/static/videos/tennis-3-e95124ef888d0b80d3e484cb7124e551.webm";